<template>
  <button
    :class="[
      'flex overflow-hidden gap-2 justify-center items-center px-5 py-2.5 !rounded-lg border',
      {
        'text-white bg-blue-700 border-blue-700 hover:bg-blue-800':
          type === 'primary' && !outline && !disabled
      },
      {
        'text-gray-700 bg-white border-gray-300 hover:bg-gray-100 ':
          type === 'secondary'
      },
      {
        '!text-red-700 bg-white border-red-700 outline-red-700 hover:bg-red-800 hover:text-white':
          type === 'danger'
      },
      {
        'hover:!bg-blue-700 hover:!text-white bg-white text-blue-700 border-blue-700':
          outline
      },
      className,
      {
        'cursor-not-allowed': disabled
      },
      {
        'text-white bg-blue-400 border-blue-400 hover:!bg-blue-500':
          disabled && type !== 'danger'
      },
      { 'text-primary hover:bg-transparent no-underline': isIconButton }
    ]"
    :data-cy="testId"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <div v-if="!saving" class="flex items-center gap-2">
      <i v-if="icon && iconPosition !== 'right'" :class="[`${icon}`]"></i>
      <slot>{{ text }}</slot>
      <slot name="label"></slot>
      <i v-if="icon && iconPosition === 'right'" :class="[`${icon}`]"></i>
    </div>
    <Spinner v-else class="saving-spinner" />
  </button>
</template>

<script>
import { kebabCase } from "@/lib/helpers.js";

import Spinner from "@/components/Spinner.vue";
export default {
  components: {
    Spinner
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "primary"
    },
    outline: {
      type: Boolean,
      default: false
    },
    iconPosition: {
      type: String,
      default: "left"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      if (this.isIconButton) {
        return "btn-plain btn-link btn-icon";
      }
      return "";
      // let className = "btn-";
      // if (this.outline) {
      //   className += "outline-";
      // }
      // return (className += this.type);
    },
    isIconButton() {
      return this.icon && !this.text & !this.$slots.default;
    },
    testId() {
      return kebabCase(this.text) || `button-${this.type}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.saving-spinner {
  padding: 5px 30px;
}
.btn-icon {
  border: none;
  padding: 0 !important;
}
</style>
